import { BaseApi } from './base.api.js';

export class DeadLetterApi extends BaseApi {
    constructor(client) { super(client, '/dead-letter-events'); }

    list(params = {}) { return this.client.get(this.basePath, { params }).then((r) => r.data); }

    metrics() { return this.client.get(`${this.basePath}/stats/metrics`).then((r) => r.data); }

    getById(id) { return this.client.get(`${this.basePath}/${id}`).then((r) => r.data); }

    retry(id) { return this.client.post(`${this.basePath}/${id}/retry`, {}).then((r) => r.data); }

    abandon(id) { return this.client.post(`${this.basePath}/${id}/abandon`, {}).then((r) => r.data); }

    retryAll(body) { return this.client.post(`${this.basePath}/actions/retry-all`, body).then((r) => r.data); }

    abandonAll(body) { return this.client.post(`${this.basePath}/actions/abandon-all`, body).then((r) => r.data); }

    purge(body) { return this.client.post(`${this.basePath}/actions/purge`, body).then((r) => r.data); }
}
